import Repository from './repository';

const resource = '/dashboard_settings';
export default {
	getDashboardSettings() {
		return Repository.getWithAuth(`${resource}`);
	},
	updateDashboardSettings(payload) {
		return Repository.postWithAuth('/dashboard_settings', payload);
	},
	resetSettings() {
		return Repository.postWithAuth(`${resource}/reset`);
	},
	getOptions() {
		return Repository.getWithAuth(`${resource}/options`);
	},
};
